module.exports = __webpack_public_path__ + "static/assets/89a47cc51a7442319faa53fb8be65434.svg";